export default __webpack_public_path__ + "e421eeb80f1f4787f526601d8f480cf8.png";